import { render, staticRenderFns } from "./rating-feedback.vue?vue&type=template&id=762906a0&"
import script from "./rating-feedback.vue?vue&type=script&lang=js&"
export * from "./rating-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports